import { InstituteListTable } from '../components/InstituteListTable';

export function InstituteListPage() {
  return <InstituteListTable />;
}
